(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hilo-restock-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hilo-restock-countdown')) {
    customElements.define('hilo-restock-countdown', class extends HTMLElement {
      connectedCallback() {
        const deadline = Date.parse('2026-10-26T17:00:00-05:00');
        const update = () => {
          const remaining = Math.ceil((deadline - Date.now()) / 1000);
          if (remaining <= 0) {
            this.hidden = true;
            clearInterval(this.interval);
            return;
          }
          const values = { hours: Math.floor(remaining / 3600), minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
          for (const [unit, value] of Object.entries(values)) {
            this.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2, '0');
          }
          this.hidden = false;
        };
        this.interval = setInterval(update, 1000);
        update();
      }
      disconnectedCallback() { clearInterval(this.interval); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
